export const switchRootClassNames = [
    '@peer',
    '@inline-flex',
    '@box-border',
    '@h-[22px]',
    '@w-[42px]',
    '@p-1',
    '@shrink-0',
    '@cursor-pointer',
    '@items-center',
    '@rounded-full',
    '@border',
    '@transition-colors',
    'focus-visible:@outline-none',
    'focus-visible:@ring-2',
    'focus-visible:@ring-ring',
    'focus-visible:@ring-offset-2',
    'focus-visible:@ring-offset-background',
    'disabled:@cursor-not-allowed',
    'disabled:@opacity-50',
    'data-[state=checked]:@bg-brand1-1',
    'data-[state=checked]:@border-brand1-1',
    'data-[state=unchecked]:@bg-grey-2',
    'data-[state=unchecked]:@border-grey-4',
];
export const switchThumbClassNames = [
    '@pointer-events-none',
    '@block',
    '@h-3',
    '@w-3',
    '@rounded-full',
    '@bg-grey-4_5',
    '@ring-0',
    '@transition-transform',
    'data-[state=checked]:before:@absolute',
    'data-[state=checked]:before:@-left-px',
    'data-[state=checked]:before:@-top-px',
    'data-[state=checked]:before:@w-[calc(100%+2px)]',
    'data-[state=checked]:before:@h-[calc(100%+2px)]',
    'data-[state=checked]:before:@border',
    'data-[state=checked]:before:@rounded-full',
    'data-[state=checked]:before:@border-grey-2_3',
    'data-[state=checked]:@bg-grey-0',
    'data-[state=checked]:@translate-x-5',
    'data-[state=unchecked]:@translate-x-0'
];
